import { type OnDestroy, Component, inject } from '@angular/core';
import {FirebaseService} from './core/services/firebase.service';
import {Subscription} from 'rxjs';

import { NavMenuComponent } from './nav-bar/nav-menu.component';
import { ShoppingCartComponent } from './features/ordering/shopping-cart.component';
import { FloatButtonComponent } from './shared/components/float-button/float-button.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [NavMenuComponent, ShoppingCartComponent, FloatButtonComponent, RouterOutlet]
})
export class AppComponent implements OnDestroy {
    private fireBaseService = inject(FirebaseService);

    title = 'bddineAngularNew';
    subscriptions: Subscription = new Subscription();
    bannerText = 'Due to the price increase of food items, we have revised our menu with a small price increase.';

    constructor() {
        this.fireBaseService.getBannerText().subscribe(data => {
            const allBannerTexts = data?.map(x => x.data());
            this.bannerText = allBannerTexts.filter(b => b.showBanner)
                .sort((a, b) => a.sortOrder - b.sortOrder)?.[0]?.bannerText;
            });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
